import React from 'react'
import { Button, Table, Pagination } from 'semantic-ui-react'
import {getStatus} from "../misc/Helpers";

function TripTable({ trips, handleDeleteTrip, handleTripPaginationChange }) {
  let tripList
  let activePage
  let totalPages
  if (!trips) {
    tripList = (
      <Table.Row key='no-user'>
        <Table.Cell collapsing textAlign='center' colSpan='6'>Нет поездок</Table.Cell>
      </Table.Row>
    )
  } else {
    activePage = trips.number
    totalPages = trips.totalPages
    tripList = trips.content.map(trip => {
      return (
        <Table.Row key={trip.id}>
          <Table.Cell collapsing>
            <Button
              circular
              color='red'
              size='small'
              icon='trash'
              onClick={() => handleDeleteTrip(trip.id)}
            />
          </Table.Cell>
          <Table.Cell>{trip.id}</Table.Cell>
          <Table.Cell>{trip.fromCity}</Table.Cell>
          <Table.Cell>{trip.toCity}</Table.Cell>
          <Table.Cell>{new Date(trip.tripTime).toLocaleString('ru',
            { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })}</Table.Cell>
          <Table.Cell>{trip.driver.username}</Table.Cell>
          <Table.Cell>{trip.driver.name}</Table.Cell>
          <Table.Cell>{trip.driver.phone}</Table.Cell>
          <Table.Cell>{getStatus(trip.status)}</Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <>
      <Table compact striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}/>
            <Table.HeaderCell width={1}>ID</Table.HeaderCell>
            <Table.HeaderCell width={2}>Откуда</Table.HeaderCell>
            <Table.HeaderCell width={2}>Куда</Table.HeaderCell>
            <Table.HeaderCell width={3}>Дата</Table.HeaderCell>
            <Table.HeaderCell width={2}>Водитель</Table.HeaderCell>
            <Table.HeaderCell width={2}>Имя</Table.HeaderCell>
            <Table.HeaderCell width={2}>Телефон</Table.HeaderCell>
            <Table.HeaderCell width={2}>Статус</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {tripList}
        </Table.Body>
      </Table>
      <Pagination
        activePage={activePage+1}
        boundaryRange={1}
        onPageChange={handleTripPaginationChange}
        size='mini'
        totalPages={totalPages}
      />
    </>
  )
}

export default TripTable
